// An address the application does not know.
//
// It rendered as two unstyled lines flush against the top-left corner of the frame: no
// padding, no heading weight, and the way back was body text that happened to be a
// link. Somebody who mistyped an address got something that looked like a page which
// had failed to load rather than an answer to what they typed.
//
// # Its own file, because two places answer with it
//
// The router's catch-all is one. The other is `/setup/:step` with a step riksu does not
// have — `/setup/jobss` is a typo, and quietly showing the entity list instead would
// tell somebody their bookmark works when it does not.
//
// It could have stayed in `app.tsx` and been imported from there, and that is a cycle:
// `app` renders `setup`, `setup` would import from `app`. A screen two screens need is
// a screen of its own.
//
// # Not built through `Page`
//
// `Page` renders a title as the screen's `h2`, and the title here would be the whole
// message. `Broken` is the same shape for the same reason. Two is not a pattern; if a
// third arrives it becomes one.

import { NavLink } from "react-router";
import { useT } from "../shell/i18n";

export function NotFound() {
  const t = useT();
  return (
    <div className="mr-auto flex max-w-(--frame-prose) flex-col items-start gap-3 px-4 py-8 lg:px-10 lg:py-10">
      <h2 className="m-0 text-[length:var(--type-shell-surface-title-size)] font-medium">
        {t("nav.notFound")}
      </h2>
      <p className="m-0 text-shell-body text-muted-foreground">{t("nav.notFoundDetail")}</p>
      {/* A BUTTON-SHAPED LINK, because it is the only thing to do here and a sentence
          of body text does not read as one. Still a `NavLink`: it is a navigation, so
          it keeps the middle-click, the copy-link and the browser's own handling that
          a button would take away. */}
      <NavLink
        to="/"
        viewTransition
        className="mt-1 inline-flex h-8 items-center rounded-lg border border-input px-3 text-shell-body font-medium hover:bg-surface-hover"
      >
        {t("nav.home")}
      </NavLink>
    </div>
  );
}
